(function () {
  // URL kulcs -> tab felirat
  const TAB_MAP = {
    "macbook-air": "MacBook / Air",
    "macbookair": "MacBook / Air",
    "macbook": "MacBook / Air",
    "air": "MacBook / Air",

    "macbook-pro": "MacBook Pro",
    "macbookpro": "MacBook Pro",
    "mbp": "MacBook Pro",
    "pro": "MacBook Pro",

    "imac-pro": "iMac / Pro",
    "imacpro": "iMac / Pro",
    "imac": "iMac / Pro",

    "mac-mini-pro-xserve": "Mac mini / Pro / Xserve",
    "macminiproxserve": "Mac mini / Pro / Xserve",
    "mac-mini": "Mac mini / Pro / Xserve",
    "macmini": "Mac mini / Pro / Xserve",
    "xserve": "Mac mini / Pro / Xserve"
  };

  function norm(s) {
    return (s || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")  // ékezetek le
      .replace(/[\s/]+/g, " ")                          // több space + / egységesít
      .replace(/\s+/g, " ")
      .trim();
  }

  function getRequestedKey() {
    const h = (window.location.hash || "").replace("#", "").trim();
    if (h) return h.toLowerCase();
    const q = new URLSearchParams(window.location.search).get("tab");
    return (q || "").trim().toLowerCase() || null;
  }

  function findClickableByLabel(label) {
    const target = norm(label);

    // A valódi tabok általában a MAIN / article környékén vannak
    const scope = document.querySelector("main") || document.body;

    // Gombok + linkek + role="tab"
    const els = Array.from(scope.querySelectorAll('button, a, [role="tab"]'))
      .map(el => el.closest('button, a, [role="tab"]') || el);

    // Csak látható elemek
    const visible = els.filter(el => {
      if (!el) return false;
      if (el.getClientRects().length === 0) return false;
      // ne a menüben lévő navigációs linket kapjuk el elsőnek
      if (el.closest('header, nav, .Header, .Drawer, .MobileNav')) return false;
      return true;
    });

    for (const el of visible) {
      const txt = norm(el.getAttribute("aria-label") || el.textContent);
      if (!txt) continue;

      // Pontos egyezés vagy “tartalmazás” (a / miatt)
      if (txt === target || txt.includes(target) || target.includes(txt)) {
        return el;
      }
    }

    return null;
  }

  // Programmatic click, de NEM engedjük, hogy elnavigáljon (akkor sem, ha még nincs init)
  function safeClickNoNav(el) {
    if (!el) return false;

    // Ha link és külső/oldalváltó href-je van, a default navigációt muszáj tiltani
    const isLink = el.tagName === "A";
    const href = isLink ? (el.getAttribute("href") || "") : "";

    // Kattintás: cancelable event, amit mi mindig preventDefault-olunk (navigáció tiltás)
    const evt = new MouseEvent("click", { bubbles: true, cancelable: true, view: window });

    // Ideiglenes capture handler: biztosan letiltja a navigációt ennél a kattintásnál
    const capture = function (e) {
      if (e.target === el || (e.target && e.target.closest && e.target.closest("a,button,[role='tab']") === el)) {
        e.preventDefault();
      }
    };

    document.addEventListener("click", capture, true);
    el.dispatchEvent(evt);
    document.removeEventListener("click", capture, true);

    // Ha nem link, vagy # href, akkor oké
    if (!isLink) return true;
    if (href.startsWith("#") || href === "") return true;

    // Link volt, de mi tiltottuk a navigációt; a tab rendszernek ilyenkor át kell vennie a vezérlést
    return true;
  }

  function openTabFromUrl() {
    const key = getRequestedKey();
    if (!key) return;

    const label = TAB_MAP[key];
    if (!label) return;

    const tryOpen = () => {
      const el = findClickableByLabel(label);
      if (!el) return false;
      safeClickNoNav(el);
      return true;
    };

    // 1) azonnali próbálkozás
    if (tryOpen()) return;

    // 2) várunk, amíg a tab UI felépül / JS inicializál
    let tries = 0;
    const maxTries = 80; // ~8-10 mp

    const timer = setInterval(() => {
      tries++;
      if (tryOpen() || tries >= maxTries) clearInterval(timer);
    }, 120);

    const obs = new MutationObserver(() => {
      if (tryOpen()) {
        clearInterval(timer);
        obs.disconnect();
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", openTabFromUrl);
  window.addEventListener("hashchange", openTabFromUrl);
})();